module.exports = __webpack_public_path__ + "img/Boton_reiniciar_valores.0f4f61b5.png";